module.exports = __webpack_public_path__ + "static/IHS Markit-1c594652004babf8c019ae814f891b5f.png";